import { Injectable } from '@angular/core';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AdddAttributeDialogService {
	public request$: Subject<any> = new Subject();
	constructor() { }

	Show(handler: AnyHandler, layer: SLLayer) {
		this.request$.next({ handler: (handler), layer: (layer) });
	}
}
